module.exports = __webpack_public_path__ + "img/5.5326f68d.png";